// extracted by mini-css-extract-plugin
module.exports = {"expandableContentToggle":"ExpandableContent_expandableContentToggle__URDa3"};